import { render } from "./Register.vue?vue&type=template&id=5665afa0&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=5665afa0&lang=less&scoped=true"

import exportComponent from "/data/app_data/product_data/deploy-center-mars/s3-deploy/damocstp/panel-cspt/v1.4.2-20260320-150211/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5665afa0"]])

export default __exports__